/**
 * Shim that re-exports react-dom and adds findDOMNode for dependencies (e.g. react-onclickoutside)
 * that still use it. React 19 removed findDOMNode; this uses React internals when available.
 * Use alias 'actual-react-dom' -> real react-dom so this file can require it without circular resolve.
 */
const ReactDOM = require('actual-react-dom');

function findDOMNode(componentOrElement) {
  if (componentOrElement == null) return null;
  if (
    typeof componentOrElement === 'object' &&
    componentOrElement.nodeType === 1
  ) {
    return componentOrElement;
  }
  const fiber = componentOrElement._reactInternals;
  if (fiber && typeof fiber.stateNode !== 'undefined') {
    let node = fiber;
    while (node) {
      if (node.stateNode && node.stateNode.nodeType === 1)
        return node.stateNode;
      node = node.child;
    }
  }
  return null;
}

module.exports = { ...ReactDOM, findDOMNode };
